import React from "react";

const Section3 = () => {
  return (
    <div className="container-1280 xl:min-w-[70%] lg:min-w-[90%] w-[95%] m-auto py-5 md:py-10">
      <div className="grid items-center grid-cols-1 gap-10 md:grid-cols-2">
        <div className="flex flex-col gap-4">
          <h2 className="text-[26px] md:text-[30px] font-bold text-red-600 leading-[28px] md:leading-[34px]">
            Why Choose Mean3 as Your Website Development Company in New York?
          </h2>

          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-[#DA2128] rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-sm text-gray-700">
                <span className="font-semibold">Shopify, Magento, and WooCommerce ecommerce specialists</span> focused on high conversion
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-[#DA2128] rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-sm text-gray-700">
                <span className="font-semibold">Custom, SEO-friendly, mobile-first builds</span> with performance and security audits included
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-[#DA2128] rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-sm text-gray-700">
                <span className="font-semibold">Innovative development using AI, blockchain integrations, and advanced automation tools</span>
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-[#DA2128] rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-sm text-gray-700">
                <span className="font-semibold">Deep focus on UI/UX, branding, and conversion strategy</span> to create memorable digital experiences
              </p>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-2 h-2 bg-[#DA2128] rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-sm text-gray-700">
                <span className="font-semibold">Flexible engagement models tailored for startups to large enterprises</span> offering cost transparency and predictable timelines
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <img src="/assets/why-choose-mean3-nyc.jpeg" alt="Why Choose Mean3 in New York" className="w-[80%]" />
        </div>
      </div>
      <div className="w-full h-px mt-10 bg-gray-800"></div>
    </div>
  );
};

export default Section3;
